import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { InsertDocumentRecordRPC } from "./insertDocumentRecordRPC";

export class InsertDocumentRecordRPCClientImpl extends InsertDocumentRecordRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: InsertDocumentRecordRPC.Request): Promise<LeoRPCResult<InsertDocumentRecordRPC.Response, InsertDocumentRecordRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "document/InsertDocumentRecord",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      InsertDocumentRecordRPC.ResponseDTO,
      InsertDocumentRecordRPC.Errors.ErrorsDTO,
      InsertDocumentRecordRPC.Response,
      InsertDocumentRecordRPC.Errors.Errors
    >(
      response,
      "document/InsertDocumentRecord",
      InsertDocumentRecordRPC.Response.fromDTO,
      InsertDocumentRecordRPC.Errors.fromDTO
    );
  }
}
